import React, { useState } from "react";

export default function RightActionArea({ children }) {
  return (
    <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
      {children}
    </div>
  );
}
